import { Box, Divider, Typography, useTheme } from "@mui/material";

const Footer = ({customStyle}) => {
  const theme = useTheme();

  return (
    <Box sx={{ pb: 2, bgcolor: theme.palette.background.default }}>
      <Divider
        variant="fullWidth"
        sx={{ borderColor: theme.palette.doveGrey, pb: 1, ...customStyle }}
      />
      <Typography
        variant="caption"
        sx={{
          fontFamily: "sans-serif",
          fontWeight: 400,
          fontSize: ".875rem",
          lineHeight: "1.19875rem",
          ...customStyle,
        }}
      >
        &copy;&nbsp;{new Date().getFullYear()} Air Canada. For internal use
        only.
      </Typography>
    </Box>
  );
};

export default Footer;
